module.exports = __webpack_public_path__ + "static/img/about4.2e8f6e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about4.png
// module id = QP2w
// module chunks = 1